<template>
  <div class="md:rounded-xxl dark:bg-hero-purple">
    <div v-if="isLoading">
      <div class="whiteBackGround dark:bg-purple-600">
        <Loader />
        <div class="loader-overlay"></div>
      </div>
    </div>
    <div v-if="!isLoading">
      <div class="headerResults">
        <div class="footerRowInfoResults" :style="{'display': showResultsHeader }">
          <div v-if="$store.state.darkMode">
            <img
              src="./images/cu-logoDarkMode.svg"
              class="footerPicDesktopResults"
              alt="Carleton University Logo"
            />
          </div>
          <div v-else>
            <img
              src="./images/dar-cu.png"
              class="footerPicDesktopResults"
              alt="Carleton University Logo"
            />
          </div>

          <div class="verticalBar"></div>
          <div class="footer2">
            <h1 class="textForFooterDesktop text-xs dark:text-white md:text-xl">
              Wellness Services Navigator
            </h1>
          </div>
          <div style="padding; 45px; dispaly: inline-block; float: right">
            <AcknowledgementsModal />
          </div>
        </div>
      </div>
      <div
        class="block mt-0"
        style="
          max-width: 1200px;
          padding: 35px 0;
          margin: 0 auto;
          border-top: 1px solid #efefef;
          text-align: center;
        "
      >
        <svg
          width="89"
          height="88"
          viewBox="0 0 89 88"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="ml-auto mr-auto mb-2 sm:mb-4 w-16 sm:w-full"
        >
          <circle cx="37.539" cy="50.2316" r="37.539" fill="#3F3D56" />
          <path
            d="M38.3159 61.6565L19.455 42.9153C18.1774 41.643 18.1786 39.5829 19.4575 38.3121C20.7365 37.0413 22.8097 37.0401 24.0901 38.3096L38.0023 52.1334L82.3969 1.82966C83.5909 0.480439 85.6591 0.347117 87.0186 1.53172C88.3781 2.71633 88.5151 4.7712 87.3248 6.1237L38.3159 61.6565Z"
            fill="#6C63FF"
          />
        </svg>
        <div class="px-6">
          <h2 class="text-xl sm:text-2xl font-medium mb-2 dark:text-white">
            Your Wellness Service Navigator Results are Ready!
          </h2>
          <p class="dark:text-white">
            We have compiled a list of various services and resources we think
            you might find useful!
          </p>
        </div>
      </div>

      <div class="backgroundMiddleResults dark:bg-purple-600">
        <div class="resultsPadding dark:bg-purple-600">
          <!--
          <h1 class="dark:text-white">Answers</h1>
          <p>-------------------------------------------</p>
          <span v-for="answer in $store.state.service_terms" :key="answer">
            <h1 class="dark:text-white">{{ answer }}</h1>
          </span>
          <p>-------------------------------------------</p>
          <h1 class="dark:text-white">Services</h1>
          <p>-------------------------------------------</p>
          <span
            v-for="service in allSortedResultsArr"
            :key="service.service_title"
          >
            <h1 class="dark:text-white">{{ service.service_title }}</h1>
          </span>
         
          <span
            v-for="service in allSortedResultsArr_reserve"
            :key="service.service_title"
          >
            <h1 class="dark:text-white">{{ service.service_title }}</h1>
          </span>
           -->
          <div class="splitDiv">
            <div class="splitDivFlex" style="height: auto">
              <h2 class="resultsTitle dark:text-white">
                Health and Wellness Support Services
              </h2>

              <div v-if="totalServices === 0 && merged2And3ServiceTotal === 0">
                <p class="font-base dark:text-white">
                  {{ noResultsLeft }}
                </p>
                <br />
              </div>
              <div v-if="totalServices > 0 || merged2And3ServiceTotal > 0">
                <p
                  class="
                    font-normal
                    text-sm
                    w-full
                    mb-6
                    leading-normal
                    dark:text-white
                  "
                >
                  Based on your responses, this is a selection of services that
                  are available to you and that you may want to consider
                  exploring. If you’ve already tried a service, or are not
                  interested, you can click the X to remove the service from
                  your results and generate additional services. <br />
                  <br />If you're still not sure where to start, or if you just
                  want to talk, please
                  <a
                    class="
                      text-link-blue
                      dark:text-link-light-blue
                      font-bold
                      pb-0.5
                    "
                    href="https://wellness.carleton.ca/get-help-now/"
                    target="_blank"
                    >reach out for assistance</a
                  >
                  - we're here to help!
                </p>
                <p class="mb-3 font-bold dark:text-white">
                  {{ totalServices }} services found
                </p>
              </div>
            </div>
          </div>

          <div
            v-if="totalServices > 0"
            id="toSlide"
            class="divBottom bottomRow"
            v-on:scroll.passive="handleScroll()"
          >
            <!-- crisis display (for now)

            <div class="divForServices" v-if="crisisBoolean">
              <span v-for="service in crisisArr" :key="service.service_title">
                <article
                  class="serviceDiv"
                  data-aos="flip-down"
                  data-aos-once="true"
                >
                  <a
                    class="serviceDivClickable"
                    v-on:click="
                      openModal(
                        $event,
                        service.service_title,
                        service.service_description,
                        service.service_link,
                        service.service_primary_modality,
                        service.service_secondary_modality,
                        service.nav_app_theme
                      )
                    "
                  >
                    <div class="serviceDivtoprow">
                      <div class="serviceDivtoprowLeft">
                        <div
                          v-if="service.nav_app_theme != ''"
                          class="serviceDivtoprowRightText"
                        >
                          {{ service.nav_app_theme }}
                        </div>
                      </div>
                      <div class="serviceDivtoprowRight">
                        <button
                          v-on:click="
                            changeServices($event, service.service_title)
                          "
                          class="changeService"
                          aria-label="Change service"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12.5"
                              cy="12.5"
                              r="12"
                              stroke="#F2F2F2"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.91395 8.50677C8.00968 8.41104 8.16488 8.41104 8.26061 8.50677L16.4934 16.7395C16.5891 16.8353 16.5891 16.9905 16.4934 17.0862C16.3976 17.1819 16.2424 17.1819 16.1467 17.0862L7.91395 8.85343C7.81822 8.7577 7.81822 8.60249 7.91395 8.50677Z"
                              fill="#0C0707"
                              stroke="#3F3D56"
                              stroke-linecap="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.81225 17.0861C7.71652 16.9904 7.71652 16.8352 7.81225 16.7395L16.045 8.50669C16.1407 8.41096 16.2959 8.41096 16.3917 8.50669C16.4874 8.60242 16.4874 8.75762 16.3917 8.85335L8.15891 17.0861C8.06318 17.1818 7.90797 17.1818 7.81225 17.0861Z"
                              fill="#0C0707"
                              stroke="#3F3D56"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="serviceDivmiddlerow">
                      <h3
                        class="
                          serviceDivmiddleRowTitle
                          font-medium
                          text-purple-600
                        "
                      >
                        {{ service.service_title }}
                      </h3>
                      <div v-if="service.nav_app_external_resource === true">
                        <h4 class="serviceDivmiddleRowTitleCampus">
                          External Service/Resource
                        </h4>
                      </div>
                      <div v-if="service.nav_app_external_resource === false">
                        <h4 class="serviceDivmiddleRowTitleCampus">
                          Carleton University Service
                        </h4>
                      </div>
                    </div>
                    <div class="serviceDivDivider"></div>
                    <div class="serviceDivbottomRow">
                      <button
                        class="serviceDivbottomRowDetails cursor-pointer"
                        style="color: #3f3d56; background-color: #e3e1fa"
                        :aria-label="detailsAria + service.service_title"
                        v-on:click="
                          openModal(
                            $event,
                            service.service_title,
                            service.service_description,
                            service.service_link,
                            service.service_primary_modality,
                            service.service_secondary_modality,
                            service.nav_app_theme
                          )
                        "
                      >
                        Get Details
                      </button>

                      <a
                        class="serviceDivbottomRowLink"
                        :href="service.service_link + campaignParams"
                        :title="visit + service.service_title + website"
                        v-on:click="reduceDOM($event)"
                        target="_blank"
                        style="color: #3f3d56"
                        >Visit website</a
                      >

                      <div
                        v-if="service.service_primary_modality != null"
                        class="serviceDivbottomRowSplitChange"
                      >
                        <Tooltip :text="service.service_primary_modality">
                          <div
                            v-on:click="smsText($event)"
                            class="centerSVGResults cursor-pointer"
                          >
                            <svg
                              width="26"
                              height="26"
                              viewBox="0 0 26 26"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="13" cy="13" r="13" fill="#F2F2F2" />
                              <path
                                d="M13 6C8.58125 6 5 8.90937 5 12.5C5 14.05 5.66875 15.4688 6.78125 16.5844C6.39062 18.1594 5.08438 19.5625 5.06875 19.5781C5 19.65 4.98125 19.7563 5.02187 19.85C5.0625 19.9438 5.15 20 5.25 20C7.32188 20 8.875 19.0063 9.64375 18.3938C10.6656 18.7781 11.8 19 13 19C17.4187 19 21 16.0906 21 12.5C21 8.90937 17.4187 6 13 6ZM9.00625 14.5H8.625C8.4875 14.5 8.375 14.3875 8.375 14.25V13.75C8.375 13.6125 8.4875 13.5 8.625 13.5H9.00938C9.19688 13.5 9.33437 13.3906 9.33437 13.2937C9.33437 13.2531 9.30938 13.2094 9.26875 13.175L8.58437 12.5875C8.31875 12.3625 8.16875 12.0406 8.16875 11.7094C8.16875 11.0437 8.7625 10.5031 9.49375 10.5031H9.875C10.0125 10.5031 10.125 10.6156 10.125 10.7531V11.2531C10.125 11.3906 10.0125 11.5031 9.875 11.5031H9.49062C9.30312 11.5031 9.16563 11.6125 9.16563 11.7094C9.16563 11.75 9.19062 11.7937 9.23125 11.8281L9.91563 12.4156C10.1813 12.6406 10.3313 12.9625 10.3313 13.2937C10.3344 13.9594 9.7375 14.5 9.00625 14.5ZM15 14.25C15 14.3875 14.8875 14.5 14.75 14.5H14.25C14.1125 14.5 14 14.3875 14 14.25V12.1188L13.225 13.8625C13.1344 14.0469 12.8687 14.0469 12.7781 13.8625L12 12.1188V14.25C12 14.3875 11.8875 14.5 11.75 14.5H11.25C11.1125 14.5 11 14.3875 11 14.25V11C11 10.725 11.225 10.5 11.5 10.5H12C12.1906 10.5 12.3625 10.6063 12.4469 10.775L13 11.8812L13.5531 10.775C13.6375 10.6063 13.8125 10.5 14 10.5H14.5C14.775 10.5 15 10.725 15 11V14.25ZM16.5094 14.5H16.125C15.9875 14.5 15.875 14.3875 15.875 14.25V13.75C15.875 13.6125 15.9875 13.5 16.125 13.5H16.5094C16.6969 13.5 16.8344 13.3906 16.8344 13.2937C16.8344 13.2531 16.8094 13.2094 16.7688 13.175L16.0844 12.5875C15.8188 12.3625 15.6687 12.0406 15.6687 11.7094C15.6687 11.0437 16.2625 10.5031 16.9937 10.5031H17.375C17.5125 10.5031 17.625 10.6156 17.625 10.7531V11.2531C17.625 11.3906 17.5125 11.5031 17.375 11.5031H16.9906C16.8031 11.5031 16.6656 11.6125 16.6656 11.7094C16.6656 11.75 16.6906 11.7937 16.7312 11.8281L17.4156 12.4156C17.6812 12.6406 17.8313 12.9625 17.8313 13.2937C17.8344 13.9594 17.2406 14.5 16.5094 14.5Z"
                                fill="#656565"
                              />
                            </svg>
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </a>
                </article>
              </span>
            </div>
            -->

            <!-- if there are no crisis results -->

            <div class="divForServices" v-if="!crisisBoolean">
              <span
                v-for="service in allSortedResultsArr"
                :key="service.service_title"
              >
                <article
                    v-if="service"
                  class="serviceDiv dark:bg-hero-purple"
                  data-aos="flip-down"
                  data-aos-once="true"
                >
                  <a
                    class="serviceDivClickable"
                    v-on:click="
                      openModal(
                        $event,
                        service.service_title,
                        service.service_description,
                        service.service_link,
                        service.service_primary_modality,
                        service.service_secondary_modality,
                        service.nav_app_theme,
                        service.service_phone_number,
                        service.service_email
                      )
                    "
                  >
                    <!--
                      <div class="serviceDivtoprowLeft">
                        <div
                          v-if="service.nav_app_theme != ''"
                          class="serviceDivtoprowRightText"
                        >
                          {{ service.nav_app_theme }}
                        </div>
                      </div>
                      -->

                    <button
                      v-on:click="
                        removeServiceConfirm(
                          $event,
                          service.service_title,
                          priority_1
                        )
                      "
                      class="changeService"
                      aria-label="Change service"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 25 25"
                        fill="white"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12.5" cy="12.5" r="12" stroke="#F2F2F2" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.91395 8.50677C8.00968 8.41104 8.16488 8.41104 8.26061 8.50677L16.4934 16.7395C16.5891 16.8353 16.5891 16.9905 16.4934 17.0862C16.3976 17.1819 16.2424 17.1819 16.1467 17.0862L7.91395 8.85343C7.81822 8.7577 7.81822 8.60249 7.91395 8.50677Z"
                          fill="#0C0707"
                          stroke="#3F3D56"
                          stroke-linecap="round"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.81225 17.0861C7.71652 16.9904 7.71652 16.8352 7.81225 16.7395L16.045 8.50669C16.1407 8.41096 16.2959 8.41096 16.3917 8.50669C16.4874 8.60242 16.4874 8.75762 16.3917 8.85335L8.15891 17.0861C8.06318 17.1818 7.90797 17.1818 7.81225 17.0861Z"
                          fill="#0C0707"
                          stroke="#3F3D56"
                          stroke-linecap="round"
                        />
                      </svg>
                    </button>

                    <div class="serviceDivmiddlerow">
                      <h3
                        class="
                          serviceDivmiddleRowTitle
                          font-medium
                          text-lg
                          dark:text-link-light-blue
                        "
                      >
                        {{ service.service_title }}
                      </h3>
                    </div>
                    <div class="serviceDivDivider"></div>
                    <div class="serviceDivbottomRow">
                      <button
                        class="serviceDivbottomRowDetails cursor-pointer"
                        style="color: #3f3d56; background-color: #e3e1fa"
                        :aria-label="detailsAria + service.service_title"
                        v-on:click="
                          openModal(
                            $event,
                            service.service_title,
                            service.service_description,
                            service.service_link,
                            service.service_primary_modality,
                            service.service_secondary_modality,
                            service.nav_app_theme,
                            service.service_phone_number,
                            service.service_email
                          )
                        "
                      >
                        Get Details
                      </button>
                      <!--
                      <a
                        class="serviceDivbottomRowLink dark:text-white"
                        :href="service.service_link + campaignParams"
                        :title="visit + service.service_title + website"
                        v-on:click="reduceDOM($event)"
                        target="_blank"
                        >Visit website</a
                      >
                      -->
                      <div
                        v-if="service.service_primary_modality != null"
                        class="serviceDivbottomRowSplitChange"
                      ></div>
                    </div>
                  </a>
                </article>
              </span>
            </div>
          </div>
          <!-- left and right arrows for the merged arrs 
          <div class="splitDivFlex">
            <div
              class="alignForwardBackButtons"
              v-if="merged2And3ServiceTotal > 0"
            >
              <button
                v-on:click="goLeftBottom"
                id="scrollLeftButton2"
                tabindex="5"
                class="cursor-pointer"
                aria-label="Scroll left"
                :disabled="disableLeft"
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="#E5E5E5" />
                  <path
                    d="M19.0778 25.6407C19.2388 25.811 19.4625 25.9097 19.7131 25.9097C20.2052 25.9097 20.6078 25.5062 20.6078 25.013C20.6078 24.7619 20.5094 24.5378 20.3483 24.3764L17.4046 21.4263H25.9763C26.4685 21.4263 26.8711 21.0228 26.8711 20.5297C26.8711 20.0365 26.4685 19.633 25.9763 19.633H17.3957L20.3394 16.683C20.5005 16.5216 20.5989 16.2974 20.5989 16.0463C20.5989 15.5532 20.1962 15.1497 19.7041 15.1497C19.4536 15.1497 19.2299 15.2483 19.0688 15.4097L14.5951 19.893C14.434 20.0544 14.3356 20.2786 14.3356 20.5297C14.3356 20.7807 14.443 20.9959 14.604 21.1573L19.0778 25.6407Z"
                    fill="#3F3D56"
                  />
                </svg>
              </button>

              <button
                v-on:click="goRightBottom"
                tabindex="4"
                class="cursor-pointer"
                aria-label="Scroll right"
                id="scrollRightButton2"
                :disabled="disableRight"
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="20" cy="20" r="20" fill="#E5E5E5" />
                  <path
                    d="M21.1288 15.4187C20.9677 15.2483 20.744 15.1497 20.4935 15.1497C20.0014 15.1497 19.5987 15.5532 19.5987 16.0463C19.5987 16.2974 19.6971 16.5216 19.8582 16.683L22.8019 19.633H14.2302C13.7381 19.633 13.3354 20.0365 13.3354 20.5297C13.3354 21.0228 13.7381 21.4263 14.2302 21.4263H22.8109L19.8671 24.3764C19.7061 24.5378 19.6077 24.7619 19.6077 25.013C19.6077 25.5062 20.0103 25.9097 20.5024 25.9097C20.753 25.9097 20.9766 25.811 21.1377 25.6496L25.6115 21.1663C25.7725 21.0049 25.8709 20.7807 25.8709 20.5297C25.8709 20.2786 25.7636 20.0634 25.6025 19.902L21.1288 15.4187Z"
                    fill="#3F3D56"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div
            v-if="merged2And3ServiceTotal > 0"
            id="toSlide2"
            v-on:scroll.passive="handleScroll2()"
            class="divBottom bottomRow"
          >
            sorted 2 and 3

            <div class="divForServices" v-if="!crisisBoolean">
              <span v-for="service in merged2And3" :key="service.service_title">
                <article
                  class="serviceDiv dark:bg-hero-purple"
                  data-aos="flip-down"
                  data-aos-once="true"
                >
                  <a
                    class="serviceDivClickable"
                    v-on:click="
                      openModal(
                        $event,
                        service.service_title,
                        service.service_description,
                        service.service_link,
                        service.service_primary_modality,
                        service.service_secondary_modality,
                        service.nav_app_theme,
                        service.service_phone_number,
                        service.service_email
                      )
                    "
                  >
                    <div class="serviceDivtoprow">
                   
                      <div class="serviceDivtoprowLeft">
                        <div
                          v-if="service.nav_app_theme != ''"
                          class="serviceDivtoprowRightText"
                        >
                          {{ service.nav_app_theme }}
                        </div>
                        
                      </div>
                   
                      <div class="serviceDivtoprowRight">
                        <button
                          v-on:click="
                            removeServiceConfirm(
                              $event,
                              service.service_title,
                              priority_2_3
                            )
                          "
                          class="changeService"
                          aria-label="Change service"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 25 25"
                            fill="white"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle
                              cx="12.5"
                              cy="12.5"
                              r="12"
                              stroke="#F2F2F2"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.91395 8.50677C8.00968 8.41104 8.16488 8.41104 8.26061 8.50677L16.4934 16.7395C16.5891 16.8353 16.5891 16.9905 16.4934 17.0862C16.3976 17.1819 16.2424 17.1819 16.1467 17.0862L7.91395 8.85343C7.81822 8.7577 7.81822 8.60249 7.91395 8.50677Z"
                              fill="#0C0707"
                              stroke="#3F3D56"
                              stroke-linecap="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.81225 17.0861C7.71652 16.9904 7.71652 16.8352 7.81225 16.7395L16.045 8.50669C16.1407 8.41096 16.2959 8.41096 16.3917 8.50669C16.4874 8.60242 16.4874 8.75762 16.3917 8.85335L8.15891 17.0861C8.06318 17.1818 7.90797 17.1818 7.81225 17.0861Z"
                              fill="#0C0707"
                              stroke="#3F3D56"
                              stroke-linecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div class="serviceDivmiddlerow">
                      <h3
                        class="
                          serviceDivmiddleRowTitle
                          font-medium
                          text-lg
                          dark:text-link-light-blue
                        "
                      >
                        {{ service.service_title }}
                      </h3>
                      <div v-if="service.nav_app_external_resource === true">
                        <h4
                          class="serviceDivmiddleRowTitleCampus dark:text-white"
                        >
                          External Service/Resource
                        </h4>
                      </div>
                      <div v-if="service.nav_app_external_resource === false">
                        <h4
                          class="serviceDivmiddleRowTitleCampus dark:text-white"
                        >
                          Carleton University Service
                        </h4>
                      </div>
                    </div>
                    <div class="serviceDivDivider"></div>
                    <div class="serviceDivbottomRow">
                      <button
                        class="serviceDivbottomRowDetails cursor-pointer"
                        style="color: #3f3d56; background-color: #e3e1fa"
                        :aria-label="detailsAria + service.service_title"
                        v-on:click="
                          openModal(
                            $event,
                            service.service_title,
                            service.service_description,
                            service.service_link,
                            service.service_primary_modality,
                            service.service_secondary_modality,
                            service.nav_app_theme,
                            service.service_phone_number,
                            service.service_email
                          )
                        "
                      >
                        Get Details
                      </button>
                      
                      <a
                        class="serviceDivbottomRowLink dark:text-white"
                        :href="service.service_link + campaignParams"
                        :title="visit + service.service_title + website"
                        v-on:click="reduceDOM($event)"
                        target="_blank"
                        >Visit website</a
                      >
                     
                    </div>
                  </a>
                </article>
              </span>
            </div>
          </div>
          -->
          <div class="flex">
            <div class="flex-1">
              <h1 class="resultssubTitle dark:text-white">
                Additional Resources
              </h1>
            </div>
            <div class="flex-1 sm:block hidden">
              <h1 class="resultssubTitle ml-5 dark:text-white">
                Upcoming Events
              </h1>
            </div>
          </div>

          <div class="wrapper mb-20">
            <div v-if="healthCoverageFlag" class="middleSection">
              <div class="CUSAInfo">
                <svg
                  width="42"
                  height="42"
                  viewBox="0 0 42 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="21" cy="21" r="21" fill="white" />
                  <path
                    d="M21.0002 15.0432L13.4125 21.8181C13.3562 21.8694 13.2843 21.8933 13.2225 21.9358V28.4375C13.2225 28.5867 13.2811 28.7298 13.3852 28.8353C13.4894 28.9407 13.6307 29 13.7781 29H28.2223C28.3696 29 28.5109 28.9407 28.6151 28.8353C28.7193 28.7298 28.7778 28.5867 28.7778 28.4375V21.9372C28.7188 21.8965 28.6486 21.8733 28.5952 21.8247L21.0002 15.0432ZM24.3334 24.2188C24.3334 24.2934 24.3042 24.365 24.2521 24.4177C24.2 24.4705 24.1293 24.5001 24.0557 24.5001H22.1113V26.4688C22.1113 26.5434 22.082 26.6149 22.0299 26.6677C21.9778 26.7204 21.9072 26.75 21.8335 26.75H20.1668C20.0932 26.75 20.0225 26.7204 19.9704 26.6677C19.9183 26.6149 19.8891 26.5434 19.8891 26.4688V24.5001H17.9447C17.871 24.5001 17.8003 24.4705 17.7482 24.4177C17.6962 24.365 17.6669 24.2934 17.6669 24.2188V22.5314C17.6669 22.4568 17.6962 22.3852 17.7482 22.3325C17.8003 22.2798 17.871 22.2501 17.9447 22.2501H19.8891V20.2814C19.8891 20.2068 19.9183 20.1353 19.9704 20.0826C20.0225 20.0298 20.0932 20.0002 20.1668 20.0002H21.8335C21.9072 20.0002 21.9778 20.0298 22.0299 20.0826C22.082 20.1353 22.1113 20.2068 22.1113 20.2814V22.2501H24.0557C24.1293 22.2501 24.2 22.2798 24.2521 22.3325C24.3042 22.3852 24.3334 22.4568 24.3334 22.5314V24.2188ZM30.8156 19.3069L21.929 11.3617C21.6746 11.1289 21.3439 11 21.001 11C20.6581 11 20.3275 11.1289 20.0731 11.3617L11.1844 19.3069C11.1301 19.3563 11.0859 19.416 11.0544 19.4826C11.0229 19.5493 11.0047 19.6216 11.0008 19.6954C10.9969 19.7691 11.0074 19.843 11.0317 19.9126C11.056 19.9823 11.0936 20.0465 11.1424 20.1014L11.8857 20.9388C11.9345 20.9938 11.9935 21.0385 12.0593 21.0704C12.1251 21.1023 12.1965 21.1207 12.2694 21.1247C12.3423 21.1286 12.4152 21.118 12.484 21.0934C12.5528 21.0688 12.6162 21.0308 12.6705 20.9814L20.6328 13.8701C20.7343 13.7794 20.865 13.7294 21.0003 13.7294C21.1357 13.7294 21.2664 13.7794 21.3679 13.8701L29.3302 20.981C29.3845 21.0304 29.4479 21.0685 29.5167 21.0931C29.5855 21.1177 29.6584 21.1283 29.7313 21.1243C29.8041 21.1204 29.8755 21.1019 29.9414 21.0701C30.0072 21.0382 30.0662 20.9935 30.1149 20.9385L30.858 20.1011C30.9563 19.9901 31.0071 19.844 30.9992 19.6951C30.9912 19.5462 30.9252 19.4065 30.8156 19.3069Z"
                    fill="#6C63FF"
                  />
                </svg>
                <h3 class="font-medium mt-2">
                  {{ currentHealthCoverage.title }}
                </h3>
                <p class="mb-6">
                  {{ currentHealthCoverage.description }}
                </p>
                <a
                  :href="staticResources.healthCoverage.cusa.url"
                  target="_blank"
                  tabindex="0"
                  class="CUSAInfo_button"
                  >Discover</a
                >
              </div>
            </div>
            <div class="middleSection">
              <div class="block gap-5 md:flex flex-col space-y-4">
                <div v-if="shouldDisplayNCS">
                  <NegativeCopingInfo />
                </div>
                <div>
                  <HealthWidget />
                </div>
                <div v-if="frameworkWidget" class="flex-1">
                  <div
                    class="
                      downLoadtheGuide
                      dark:bg-hero-purple dark:border-hero-purple
                    "
                  >
                    <svg
                      width="42"
                      height="42"
                      viewBox="0 0 42 42"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="21" cy="21" r="21" fill="white" />
                      <path
                        d="M17 20.8572C18.9344 20.8572 20.5 19.3195 20.5 17.4197C20.5 15.5198 18.9344 13.9822 17 13.9822C15.0656 13.9822 13.5 15.5198 13.5 17.4197C13.5 19.3195 15.0656 20.8572 17 20.8572ZM19.4 21.8393H19.1406C18.4906 22.1462 17.7688 22.3304 17 22.3304C16.2312 22.3304 15.5125 22.1462 14.8594 21.8393H14.6C12.6125 21.8393 11 23.423 11 25.375V26.259C11 27.0723 11.6719 27.7322 12.5 27.7322H21.5C22.3281 27.7322 23 27.0723 23 26.259V25.375C23 23.423 21.3875 21.8393 19.4 21.8393ZM26 20.8572C27.6562 20.8572 29 19.5374 29 17.9107C29 16.2841 27.6562 14.9643 26 14.9643C24.3438 14.9643 23 16.2841 23 17.9107C23 19.5374 24.3438 20.8572 26 20.8572ZM27.5 21.8393H27.3813C26.9469 21.9866 26.4875 22.0849 26 22.0849C25.5125 22.0849 25.0531 21.9866 24.6187 21.8393H24.5C23.8625 21.8393 23.275 22.0204 22.7594 22.312C23.5219 23.1192 24 24.1903 24 25.375V26.5536C24 26.6211 23.9844 26.6856 23.9812 26.75H29.5C30.3281 26.75 31 26.0902 31 25.2768C31 23.377 29.4344 21.8393 27.5 21.8393Z"
                        fill="#D8232A"
                      />
                    </svg>
                    <h3 class="font-medium mt-2 dark:text-white">
                      {{ currentPrimaryReason.title }}
                    </h3>
                    <p class="mb-6 dark:text-white">
                      {{ currentPrimaryReason.description }}
                    </p>

                    <a
                      :href="currentPrimaryReason.url"
                      tabindex="0"
                      target="_blank"
                      class="downLoadtheGuide_button"
                      >Download the Guide</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <h1 class="resultssubTitle block dark:text-white sm:hidden">
              Upcoming Events
            </h1>

            <EventsListing />

            <div class="block text-center">
              <hr
                class="
                  border-solid border-t-1 border-gray-300
                  dark:border-gray-400
                "
              />
              <h1 class="resultssubTitle dark:text-white">
                We're here to help you succeed!
              </h1>

              <p
                class="
                  font-normal
                  text-sm
                  mb-6
                  dark:text-white
                  w-2/3
                  mx-auto
                  text-center
                "
              >
                Carleton offers a wide variety of support services and resources
                to support you. Whether you need help reaching your academic
                goals or managing your finances, want to get a head start on
                your career, are looking for ways to get involved or want to
                better manage your mental health and wellness, the
                <a
                  href="https://students.carleton.ca/"
                  target="_blank"
                  class="text-link-blue dark:text-link-light-blue font-bold"
                  >Current Students website</a
                >
                is designed to help you find the resources you need when you
                need them most.
              </p>
            </div>
          </div>
          <!--
          <div v-if="continuumVal !== 0" class="wrapperBottom">
            <div class="divOption2 topRow" v-bind:style="[conditionalWidth]">
              <div class="splitDiv">
                <div class="splitDivFlex" style="height: auto">
                  <h2 class="pt-2 hidden">
                    The Mental Health Continuum at Carleton
                  </h2>
                  <a
                    class="text-xs float-right border rounded-full p-2 pr-4"
                    style="cursor: pointer"
                    v-on:click="openContinuumModal()"
                    aria-label="What does this mean?"
                  >
                    <svg
                      class="float-left mr-2"
                      width="16"
                      height="16"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 6C12 9.31444 9.31348 12 6 12C2.68652 12 0 9.31444 0 6C0 2.68749 2.68652 0 6 0C9.31348 0 12 2.68749 12 6ZM6.16101 1.98387C4.84253 1.98387 4.00161 2.53928 3.34127 3.5264C3.25573 3.65429 3.28435 3.82677 3.40696 3.91974L4.24645 4.55627C4.37238 4.65177 4.5518 4.62905 4.64964 4.50494C5.08183 3.95676 5.37818 3.63888 6.036 3.63888C6.53025 3.63888 7.1416 3.95698 7.1416 4.43625C7.1416 4.79857 6.84249 4.98465 6.35448 5.25825C5.78535 5.57729 5.03226 5.97438 5.03226 6.96774V7.06452C5.03226 7.22485 5.16225 7.35484 5.32258 7.35484H6.67742C6.83775 7.35484 6.96774 7.22485 6.96774 7.06452V7.03227C6.96774 6.34367 8.98031 6.315 8.98031 4.45161C8.98031 3.04834 7.5247 1.98387 6.16101 1.98387V1.98387ZM6 7.98387C5.38633 7.98387 4.8871 8.4831 4.8871 9.09677C4.8871 9.71042 5.38633 10.2097 6 10.2097C6.61367 10.2097 7.1129 9.71042 7.1129 9.09677C7.1129 8.4831 6.61367 7.98387 6 7.98387Z"
                        fill="#AEAAF1"
                      />
                    </svg>
                    <span class="font-bold">What does this mean?</span>
                  </a>
                  <div class="bottomRowTextHeight">
                    <h2 class="pt-2">
                      The Mental Health Continuum at Carleton
                    </h2>
                  </div>
                </div>
              </div>

              <div class="innerDivSections">
                <div
                  class="continuum-col-wrapper"
                  role="dialog"
                  tabindex="0"
                  :aria-label="
                    continuumNames[0] +
                    level +
                    mentalHealthContinuum.thriving.percentageFull +
                    percent
                  "
                >
                  <div
                    v-bind:style="[styleThriving]"
                    class="bar rounded-br-lg rounded-bl-lg"
                  >
                    <div class="txt">Thriving</div>
                  </div>
                </div>
                <div
                  class="continuum-col-wrapper"
                  role="dialog"
                  tabindex="0"
                  :aria-label="
                    continuumNames[1] +
                    level +
                    mentalHealthContinuum.everyday_stress.percentageFull +
                    percent
                  "
                >
                  <div
                    v-bind:style="[styleEveryday_stress]"
                    class="bar rounded-br-lg rounded-bl-lg"
                  >
                    <div class="txt">Everday</div>
                    <br />
                    <div class="txtdown">Stress</div>
                  </div>
                </div>
                <div
                  class="continuum-col-wrapper"
                  role="dialog"
                  tabindex="0"
                  :aria-label="
                    continuumNames[2] +
                    level +
                    mentalHealthContinuum.mild.percentageFull +
                    percent
                  "
                >
                  <div
                    v-bind:style="[styleMild]"
                    class="bar rounded-br-lg rounded-bl-lg"
                  >
                    <div class="txt">Mild</div>
                  </div>
                </div>
                <div
                  class="continuum-col-wrapper"
                  role="dialog"
                  tabindex="0"
                  :aria-label="
                    continuumNames[3] +
                    level +
                    mentalHealthContinuum.moderate.percentageFull +
                    percent
                  "
                >
                  <div
                    v-bind:style="[styleModerate]"
                    class="bar rounded-br-lg rounded-bl-lg"
                  >
                    <div class="txt">Moderate</div>
                  </div>
                </div>
                <div
                  class="continuum-col-wrapper"
                  role="dialog"
                  tabindex="0"
                  :aria-label="
                    continuumNames[4] +
                    level +
                    mentalHealthContinuum.complex.percentageFull +
                    percent
                  "
                >
                  <div
                    v-bind:style="[styleComplex]"
                    class="bar rounded-br-lg rounded-bl-lg"
                  >
                    <div class="txt">Complex</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="divOption1 topRow topRowRight">
              <WidgetSVG />

              <div v-if="mentalHealthContinuum.thriving.value === largestVal">
                <div
                  class="bottomRowTextHeight"
                  style="height: auto; display: block"
                >
                  <h3 class>{{ mentalHealthContinuum.thriving.name }}</h3>
                  <p class="font-normal transform-none text-md color-white">
                    {{ mentalHealthContinuum.thriving.description }}
                  </p>
                  <a
                    class="
                      bg-white
                      block
                      w-full
                      p-3
                      rounded-xl
                      text-black text-sm
                      mt-2
                    "
                    v-if="crisisBoolean"
                    target="_blank"
                    href="https://carleton.ca/health/"
                    >Learn more about Health and Counselling Services at
                    Carleton</a
                  >
                </div>
                <hr />
              </div>
              <div
                v-if="
                  mentalHealthContinuum.everyday_stress.value === largestVal
                "
              >
                <div
                  class="bottomRowTextHeight"
                  style="height: auto; display: block"
                >
                  <h3 class>
                    {{ mentalHealthContinuum.everyday_stress.name }}
                  </h3>
                  <p class="font-normal transform-none text-md color-white">
                    {{ mentalHealthContinuum.everyday_stress.description }}
                  </p>
                  <a
                    class="
                      bg-white
                      block
                      w-full
                      p-3
                      rounded-xl
                      text-black text-sm
                      mt-2
                    "
                    v-if="crisisBoolean"
                    target="_blank"
                    href="https://carleton.ca/health/"
                    >Learn more about Health and Counselling Services at
                    Carleton</a
                  >
                </div>
                <hr />
              </div>
              <div v-if="mentalHealthContinuum.mild.value === largestVal">
                <div
                  class="bottomRowTextHeight"
                  style="height: auto; display: block"
                >
                  <h3 class>{{ mentalHealthContinuum.mild.name }}</h3>
                  <p class="font-normal transform-none text-md color-white">
                    {{ mentalHealthContinuum.mild.description }}
                  </p>
                  <a
                    class="
                      bg-white
                      block
                      w-full
                      p-3
                      rounded-xl
                      text-black text-sm
                      mt-2
                    "
                    v-if="crisisBoolean"
                    target="_blank"
                    href="https://carleton.ca/health/"
                    >Learn more about Health and Counselling Services at
                    Carleton</a
                  >
                </div>
                <hr />
              </div>
              <div v-if="mentalHealthContinuum.moderate.value === largestVal">
                <div
                  class="bottomRowTextHeight"
                  style="height: auto; display: block"
                >
                  <h3 class>{{ mentalHealthContinuum.moderate.name }}</h3>
                  <p class="font-normal transform-none text-md color-white">
                    {{ mentalHealthContinuum.moderate.description }}
                  </p>
                  <a
                    class="
                      bg-white
                      block
                      w-full
                      p-3
                      rounded-xl
                      text-black text-sm
                      mt-2
                    "
                    v-if="crisisBoolean"
                    target="_blank"
                    href="https://carleton.ca/health/"
                    >Learn more about Health and Counselling Services at
                    Carleton</a
                  >
                </div>
                <hr />
              </div>
              <div v-if="mentalHealthContinuum.complex.value === largestVal">
                <div
                  class="bottomRowTextHeight"
                  style="height: auto; display: block"
                >
                  <h3 class>{{ mentalHealthContinuum.complex.name }}</h3>
                  <p class="font-normal transform-none text-md color-white">
                    {{ mentalHealthContinuum.complex.description }}
                  </p>
                  <a
                    class="
                      bg-white
                      block
                      w-full
                      p-3
                      rounded-xl
                      text-black text-sm
                      mt-2
                    "
                    v-if="crisisBoolean"
                    target="_blank"
                    href="https://carleton.ca/health/"
                    >Learn more about Health and Counselling Services at
                    Carleton</a
                  >
                </div>
              </div>
            </div>
          </div>
          -->
        </div>
      </div>
      <div v-if="confirmRemoveModal">
        <div v-on:click="closeConfirm" class="modalOverlayClose_reduced"></div>
        <div
          class="continuumDialog dark:bg-purple-600 border-2 dark:text-white"
        >
          <p class="pargraphs mb-5">
            Are you sure you want to remove this service from your results?
          </p>
          <div class="flex">
            <div class="flex-1">
              <button class="exitNavButton m-0" v-on:click="removeService">
                Yes
              </button>
            </div>
            <div class="flex-1">
              <button class="continuteNavButton m-0" v-on:click="closeConfirm">
                No
              </button>
            </div>
          </div>
          <div class="checkboxes mt-10">
            <input
              type="checkbox"
              id="cbDontShow"
              name="singleCB"
              v-on:click="dontShowAgainRemoved"
            />

            <label for="cbDontShow" class="dark:text-white dark:bg-purple-600">
              Don't show again
            </label>
          </div>
        </div>
      </div>
      <div v-if="continuumModalOpen">
        <ContinuumModal
          :value="continuumModalOpen"
          v-model="continuumModalOpen"
        />
      </div>
      <div v-if="openModal">
        <Modal
          :modalTitle="serviceTitle"
          :modalDescription="serviceDescription"
          :modalLink="serviceLink"
          :modalDelivery1="serviceDelivery1"
          :modalDelivery2="serviceDelivery2"
          :phone="servicePhoneNumber"
          :email="serviceEmail"
          :modalTheme="serviceTheme"
          :value="modalFlag"
          v-model="modalOpen"
        />
      </div>

      <div class="alignFooter dark:bg-hero-purple dark:border-t-0">
        <div class="footerContainer">
          <HelpDialog />
          <button
            v-on:click="startOverFunction"
            class="nextbuttonResults cursor-pointer"
            aria-label="Start again"
          >
            Start Again
            <span class="arrow">
              <svg
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                  fill="#8380A8"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
    <!--<img src="./images/q1_pic.png" class="questionGenPic" />-->
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import Loader from "../components/Loader.vue";
import Modal from "./Modal.vue";
import Vue from "vue";

import ContinuumModal from "./ContinuumModal.vue";
import EventsListing from "./EventsListing.vue";
// import Tooltip from "./Tooltip.vue";
//import WidgetSVG from "./WidgetSVG.vue";
import AcknowledgementsModal from "./AcknowledgementsModal.vue";
import HelpDialog from "./HelpDialog.vue";
import HealthWidget from "./HCS";
import NegativeCopingInfo from "./NCS";


export default {
  components: {
    Loader,
    Modal,
    HealthWidget,
    NegativeCopingInfo,
    ContinuumModal,
    EventsListing,
    // Tooltip,
    //WidgetSVG,
    AcknowledgementsModal,
    HelpDialog,
  },
  data() {
    return {
      darkSideLogo: false,
      added: false,
      continuumNoticeFlag: false,
      modalOpen: false,
      flagDisabled: false,
      //for modal
      campaignParams:
        "?utm_source=wellness-navigator&utm_medium=app&utm_campaign=wellness-service-ref",
      detailsAria: "Get Details about ",
      serviceTitle: "",
      serviceDescription: "",
      serviceLink: "",
      serviceDelivery1: [],
      serviceDelivery2: "",
      servicePhoneNumber: "",
      serviceEmail: "",
      serviceTheme: "",
      //end of for modal
      modalFlag: true,
      helpForFriend: false,
      modalName: "",
      modalView: false,
      modalDescription: "",
      modalLink: "",
      //resultsEmpty: false,
      services: [],
      open: false,
      continuumModalOpen: false,
      isLoading: true,
      crisisBoolean: false,
      priority2Results: false,
      priority3Results: false,
      totalServices: 0,
      serviceLoadMoreClick: 0,
      sortedArr: [],
      sortedArr2: [],
      sortedArr3: [],
      merged2And3: [],
      allSortedResultsArr: [],
      allSortedResultsArr_reserve: [],
      allSortedResultsArr_reserve_index: 0,
      merged2And3ServiceTotal: 0,
      crisisArr: [],
      continuumVal: 0,
      continuumName: "",
      continuumDescription: "",
      healthCoverageFlag: false,
      frameworkWidget: false,
      showResultsHeader: "flex",
      currentHealthCoverage: {
        title: "",
        description: "",
        url: "",
      },
      currentPrimaryReason: {
        title: "",
        description: "",
        url: "",
      },
      staticResources: {
        healthCoverage: {
          ohip: {
            title: "Residents of Ontario",
            description:
              "Please remember to carry your OHIP card at all times! If you do not have one, an application for coverage must be made at the Government Service Centre.",
            url: "https://carleton.ca/health/insurance/",
          },
          cusa: {
            title: "Did you know?",
            description:
              "All Carleton undergraduate students who are taking at least 4 courses in the Fall Term and who are members of CUSA are automatically covered by the CUSA Health & Dental Plan.",
            url: "https://www.cusaonline.ca/services/healthplan/",
          },
          // nothing else needs logic...
          other: {
            title: "",
            description: "",
            url: "",
          },
          none: {
            title: "",
            description: "",
            url: "",
          },
        },
        primaryReason: {
          self: {
            title: "Carleton Student Mental Health Framework 2.0",
            description:
              "The Carleton University Student Mental Health Framework 2.0 pdf is an important addition to Carleton University’s efforts to promote positive mental health and assist students in realizing their potential.",
            url: "https://carleton.ca/studentsupport/student-mental-health-framework/",
          },
          friend: {
            title: "Supporting a Friend",
            description:
              "It can be difficult to know how to support a friend when we aren’t sure how to respond. Often, we worry that we might make things worse by saying or doing the wrong thing. View our Supporting a Friend resource to help you recognize concerns, respond appropriately, and refer them to any of the resources at your disposal.",
            url: "https://carleton.ca/wellness/help-a-friend/",
          },
          curious: {
            title: "Carleton Student Mental Health Framework 2.0",
            description:
              "The Carleton University Student Mental Health Framework 2.0 pdf is an important addition to Carleton University’s efforts to promote positive mental health and assist students in realizing their potential.",
            url: "https://carleton.ca/studentsupport/student-mental-health-framework/",
          },
          other: {
            title: "Carleton Student Mental Health Framework 2.0",
            description:
              "The Carleton University Student Mental Health Framework 2.0 pdf is an important addition to Carleton University’s efforts to promote positive mental health and assist students in realizing their potential.",
            url: "https://carleton.ca/studentsupport/student-mental-health-framework/",
          },
        },
      },
      mentalHealthContinuum: {
        thriving: {
          value: 0,
          name: "Thriving on Campus",
          description:
            "Positive mental health and well-being, with high levels of energy, engagement and functional.",
          percentageFull: 0,
        },
        mild: {
          value: 0,
          name: "Mild Mental Health Concerns",
          description:
            "More persistent difficulties in coping, causing some anxiety or lowered mood with an impact on self-care. Problems at this level are often situational and reversible.",
          percentageFull: 0,
        },
        moderate: {
          value: 0,
          name: "Moderate Mental Health Concerns",
          description:
            "Mental health challenges or levels of distress that have a greater impact on daily functioning, academics or social interactions.",
          percentageFull: 0,
        },
        complex: {
          value: 0,
          name: "Complex Mental Health Concerns",
          description:
            "Complex mental health challenges that limit daily functioning and require specialized care, a treatment plan or monitoring.",
          percentageFull: 0,
        },
        everyday_stress: {
          value: 0,
          name: "Everyday Stress",
          description:
            "Occasional difficulties in responding to academic, personal, social, financial or health issues. These issues are common to many students",
          percentageFull: 0,
        },
      },
      conditionalFeelings: {
        0: "Depressed",
        1: "Anxious",
      },
      //check to see if more than one continuum val equal the same , if so , moreThanOneContinuumBoolean = true
      moreThanOneContinuumFlag: 0,
      moreThanOneContinuumBoolean: false,
      //check against the values and use to conditionally show the themes that are equal to it
      largestVal: 0,
      condtionalFlag: false,
      currFeeling: "",
      currFeelingWords: "",
      noResultsLeft:
        "There are no additional results that match your criteria 😔",
      feelingsAndEmjois: {
        "😃": "Content",
        "😁": "Great",
        "😐": "Ok",
        "😟": "Stressed",
        "😞": "Lonely",
        "😠": "Angry",
        "😔": "Sad",
        "😕": "Upset",
        "🙁": "Depressed",
        "😓": "Anxious",
      },

      styleThriving: {
        background: "#979797",
        height: "",
        animation: "",
      },
      styleMild: {
        background: "#979797",
        height: "",
        animation: "",
      },
      styleModerate: {
        background: "#979797",
        height: "",
        animation: "",
      },
      styleComplex: {
        background: "#979797",
        height: "",
        animation: "",
      },
      styleEveryday_stress: {
        background: "#979797",
        height: "",
        animation: "",
        flex: "",
      },

      visit: "Visit ",
      website: " website",

      level: "level is ",
      percent: "%",

      continuumNames: [
        "Thriving",
        "Everyday Stress",
        "Mild",
        "Moderate",
        "Complex",
      ],

      conditionalWidth: {
        flex: "1 0 100%",
      },
      disableLeft: true,
      disableRight: false,
      priority_1: "priority_1",
      priority_2_3: "priority_2_3",
      scrollDiv: "",
      curr_e: "",
      curr_title: "",
      curr_arr: "",
      confirmRemoveModal: false,
      preventRemoveConfirm: false,
      healthandCounsellingServices: "",
    };
  },
  
  computed: {
    shouldDisplayNCS() {
      const conditions = ['Substance', 'Eating Disorders', 'Gambling', 'Sexual Health'];
      return conditions.some(condition => this.$store.state.service_terms.includes(condition));
    },
  },

  async mounted() {
    this.loaderr();
    this.checkDarkModeStatus();
    this.sortingHat();
    this.track();
    this.checkResultsStyleLoader();
  },
  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "results-page" });
      }
    },
    openNotice() {
      this.continuumNoticeFlag = true;
    },

    closeCautionNotice() {
      this.continuumNoticeFlag = false;
    },

    reduceDOM(e) {
      e.stopPropagation();
    },

    //swap out a service

    dontShowAgainRemoved() {
      const cb = document.querySelector("#cbDontShow");

      if (cb.checked) {
        this.preventRemoveConfirm = true;
      } else {
        this.preventRemoveConfirm = false;
      }
    },

    closeConfirm() {
      this.confirmRemoveModal = false;
    },

    removeServiceConfirm(e, title, fromArr) {
      fromArr = "NULL";
      e.stopPropagation();
      this.curr_e = e;
      this.curr_title = title;
      this.curr_arr = fromArr;

      if (!this.preventRemoveConfirm) {
        this.confirmRemoveModal = true;
      } else {
        this.removeService();
      }
    },

    removeService() {
      var i;
      //e.stopPropagation();

      if (this.allSortedResultsArr_reserve.length > 0) {
        for (i = 0; i < this.allSortedResultsArr.length; i++) {
          if (this.allSortedResultsArr[i].service_title === this.curr_title) {
            Vue.set(
              this.allSortedResultsArr,
              i,
              this.allSortedResultsArr_reserve[0]
            );
            this.allSortedResultsArr_reserve.splice(0, 1);
            //this.allSortedResultsArr_reserve_index += 1;
            this.totalServices--;
            break;
          }
        }
      } else {
        /*else remove the service if there is no more to take from reserves */
        for (i = 0; i < this.allSortedResultsArr.length; i++) {
          if (this.allSortedResultsArr[i].service_title === this.curr_title) {
            Vue.set(this.allSortedResultsArr, i, null);
            this.allSortedResultsArr.splice(i, 1);
            this.totalServices--;
            break;
          }
        }
      }

      /*
      if (this.totalServices > 0) {
        var div = document.getElementById("toSlide");

        if (div.scrollWidth - 298 <= div.clientWidth) {
          var leftButton = document.getElementById("scrollLeftButton");
          var rightButton = document.getElementById("scrollRightButton");

          leftButton.disabled = true;
          rightButton.disabled = true;
        }
      }


      if (this.merged2And3ServiceTotal > 0) {
        var div2 = document.getElementById("toSlide2");
        if (div2.scrollWidth - 298 <= div2.clientWidth) {
          var leftButton2 = document.getElementById("scrollLeftButton2");
          var rightButton2 = document.getElementById("scrollRightButton2");

          leftButton2.disabled = true;
          rightButton2.disabled = true;
        }
      }
      */

      this.confirmRemoveModal = false;

      // var leftButton = document.getElementById("scrollLeftButton");
      //var rightButton = document.getElementById("scrollRightButton");
    },

    /* swap out services from priority one with 2 and 3 till none are left
    changeServices(e, title) {
      e.stopPropagation();

      var moreAvailable = false;
      var swapInSortedArr2 = false;
      var swapInSortedArr3 = false;

      var i;
      var j;

      if (!this.crisisBoolean) {
        for (i = 0; i < this.sortedArr.length; i++) {
          if (this.sortedArr[i].service_title === title) {
            for (j = 0; j < this.sortedArr2.length; j++) {
              if (
                this.sortedArr2[j] !== undefined &&
                swapInSortedArr2 === false
              ) {
                swapInSortedArr2 = true;
                Vue.set(this.sortedArr, i, this.sortedArr2[j]);
                //remove the item so that it cannnot be swapped out again
                this.sortedArr2.splice(j, 1);
                this.totalServices--;
              }
            }

            if (swapInSortedArr2 === false) {
              for (j = 0; j < this.sortedArr3.length; j++) {
                if (
                  this.sortedArr3[j] !== undefined &&
                  swapInSortedArr3 === false
                ) {
                  swapInSortedArr3 = true;
                  Vue.set(this.sortedArr, i, this.sortedArr3[j]);
                  //remove the item so that it cannnot be swapped out again
                  this.sortedArr3.splice(j, 1);
                  this.totalServices--;
                }
              }
            }
          }
        }

        if (!swapInSortedArr2 && !swapInSortedArr3) {
          this.flagDisabled = true;
        }

        if (!this.flagDisabled) {
          moreAvailable = this.findMoreAvailableCheck();

          if (moreAvailable === false) {
            this.flagDisabled = true;
          }
        } else {
          for (i = 0; i < this.sortedArr.length; i++) {
            if (this.sortedArr[i].service_title === title) {
              Vue.set(this.sortedArr, i, null);
              //remove the item so that it cannnot be swapped out again
              this.sortedArr.splice(i, 1);
              this.totalServices--;
            }
          }
        }
      } else {
        for (i = 0; i < this.crisisArr.length; i++) {
          if (this.crisisArr[i].service_title === title) {
            Vue.set(this.crisisArr, i, null);
            //remove the item so that it cannnot be swapped out again
            this.crisisArr.splice(i, 1);
            this.totalServices--;
          }
        }
      }
    },
    */

    //check if there are more services to grab from to replace , if not , this ill in turn remove the "X" button from each service

    findMoreAvailableCheck() {
      if (this.sortedArr2.length > 0 || this.sortedArr3.length > 0) {
        return true;
      }

      return false;
    },

    /*
    exploreMore() {
      if (!this.priority2Results && !this.priority3Results) {
        this.priority2Results = true;
      } else if (this.priority2Results) {
        this.priority2Results = false;
        this.priority3Results = true;
      } else {
        this.priority2Results = false;
        this.priority3Results = false;
      }
    },
    */
    openModal(e, title, des, link, devliery1, delivery2, theme, phone, email) {
      e.stopPropagation();
      this.serviceTitle = title;
      this.serviceDescription = des;
      this.serviceLink =
        link +
        "?utm_source=wellness-navigator&utm_medium=app&utm_campaign=wellness-service-ref";
      this.serviceDelivery1 = devliery1;
      this.serviceDelivery2 = delivery2;
      this.serviceTheme = theme;
      this.servicePhoneNumber = phone;
      this.serviceEmail = email;
      this.modalOpen = !this.modalOpen;

      document.title = "Visit " + title;
    },
    startOverFunction() {
      location.reload();
      if (window.location.href.indexOf("?crisis=true") != -1) {
        let url = window.location.href.split("/?");
        window.location.href = url[0];
      }
    },
    loadPriorityResults() {
      this.serviceLoadMoreClick++;
      if (this.serviceLoadMoreClick == 0) {
        this.priority2Results = true;
      } else if (this.serviceLoadMoreClick >= 1) {
        this.priority2Results = !this.priority2Results;
        this.priority3Results = !this.priority3Results;
      }
    },

    loaderr() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    serviceDetails() {
      this.modal = true;
      this.modalView = true;
    },

    sortingHat() {
      let modes = store.getters.questionFiveAnswer;

      //let q3_1 = ["undergraduate", "graduate"];
      //let q3_2 = ["international", "domestic"];
      let q3_3 = ["ottawa", "abroad", "canada", "residence"];

      const responseTerms = store.state.service_terms.map((v) =>
        v.toLowerCase()
      );

      // if index_undergraduate_answer > -1 , undergraduate , else , graduate

      var index_undergraduate_answer = responseTerms.indexOf("undergraduate");

      // if index_domestic_answer > -1 , domestic , else , international

      var index_domestic_answer = responseTerms.indexOf("domestic");

      var index_living_answer = "";

      if (responseTerms.indexOf("ottawa") > -1) {
        index_living_answer = [responseTerms.indexOf("ottawa"), "ottawa"];
      } else if (responseTerms.indexOf("abroad") > -1) {
        index_living_answer = [responseTerms.indexOf("abroad"), "abroad"];
      } else if (responseTerms.indexOf("residence") > -1) {
        index_living_answer = [responseTerms.indexOf("residence"), "residence"];
      } else {
        index_living_answer = [responseTerms.indexOf("canada"), "canada"];
      }

      // loop through the services listed in state
      store.state.services.forEach((index) => {
        let service_terms_arr = index.service_terms_arr.map((v) =>
          v.toLowerCase()
        );

        const service_terms_arr_inital = [...service_terms_arr];

        let howmany_inner_locations = service_terms_arr.filter((element) =>
          q3_3.includes(element)
        ).length;

        /*q2.1 check */

        var index_undergraduate = service_terms_arr.indexOf("undergraduate");
        var index_graduate = service_terms_arr.indexOf("graduate");

        if (index_undergraduate > -1 && index_graduate > -1) {
          if (index_undergraduate_answer > -1) {
            service_terms_arr.splice(index_graduate, 1);
          } else {
            service_terms_arr.splice(index_undergraduate, 1);
          }
        }

        /*q2.2 check */

        var index_domestic = service_terms_arr.indexOf("domestic");
        var index_international = service_terms_arr.indexOf("international");

        if (index_domestic > -1 && index_international > -1) {
          if (index_domestic_answer > -1) {
            service_terms_arr.splice(index_international, 1);
          } else {
            service_terms_arr.splice(index_domestic, 1);
          }
        }

        /*q2.3 check */

        var index_ottawa = service_terms_arr.indexOf("ottawa");
        var index_abroad = service_terms_arr.indexOf("abroad");
        var index_residence = service_terms_arr.indexOf("residence");
        var index_canada = service_terms_arr.indexOf("canada");

        if (
          howmany_inner_locations != 1 &&
          index_living_answer[0] > -1 &&
          index_living_answer[1] === "ottawa"
        ) {
          index_residence = service_terms_arr.indexOf("residence");

          if (howmany_inner_locations != 1 && index_residence > -1) {
            service_terms_arr.splice(index_residence, 1);
            howmany_inner_locations -= 1;
          }

          index_abroad = service_terms_arr.indexOf("abroad");

          if (howmany_inner_locations != 1 && index_abroad > -1) {
            service_terms_arr.splice(index_abroad, 1);
            howmany_inner_locations -= 1;
          }

          index_canada = service_terms_arr.indexOf("canada");

          if (howmany_inner_locations != 1 && index_canada > -1) {
            service_terms_arr.splice(index_canada, 1);
            howmany_inner_locations -= 1;
          }
        } else if (
          howmany_inner_locations != 1 &&
          index_living_answer[0] > -1 &&
          index_living_answer[1] === "abroad"
        ) {
          index_residence = service_terms_arr.indexOf("residence");

          if (howmany_inner_locations != 1 && index_residence > -1) {
            service_terms_arr.splice(index_residence, 1);
            howmany_inner_locations -= 1;
          }

          index_canada = service_terms_arr.indexOf("canada");

          if (howmany_inner_locations != 1 && index_canada > -1) {
            service_terms_arr.splice(index_canada, 1);
            howmany_inner_locations -= 1;
          }

          index_ottawa = service_terms_arr.indexOf("ottawa");

          if (howmany_inner_locations != 1 && index_ottawa > -1) {
            service_terms_arr.splice(index_ottawa, 1);
            howmany_inner_locations -= 1;
          }
        } else if (
          howmany_inner_locations != 1 &&
          index_living_answer[0] > -1 &&
          index_living_answer[1] === "residence"
        ) {
          index_abroad = service_terms_arr.indexOf("abroad");

          if (howmany_inner_locations != 1 && index_abroad > -1) {
            service_terms_arr.splice(index_abroad, 1);
            howmany_inner_locations -= 1;
          }

          index_canada = service_terms_arr.indexOf("canada");

          if (howmany_inner_locations != 1 && index_canada > -1) {
            service_terms_arr.splice(index_canada, 1);
            howmany_inner_locations -= 1;
          }
          index_ottawa = service_terms_arr.indexOf("ottawa");

          if (howmany_inner_locations != 1 && index_ottawa > -1) {
            service_terms_arr.splice(index_ottawa, 1);
            howmany_inner_locations -= 1;
          }
        } else if (
          howmany_inner_locations != 1 &&
          index_living_answer[0] > -1 &&
          index_living_answer[1] === "canada"
        ) {
          index_abroad = service_terms_arr.indexOf("abroad");

          if (howmany_inner_locations != 1 && index_abroad > -1) {
            service_terms_arr.splice(index_abroad, 1);
            howmany_inner_locations -= 1;
          }

          index_residence = service_terms_arr.indexOf("residence");

          if (howmany_inner_locations != 1 && index_residence > -1) {
            service_terms_arr.splice(index_residence, 1);
            howmany_inner_locations -= 1;
          }

          index_ottawa = service_terms_arr.indexOf("ottawa");

          if (howmany_inner_locations != 1 && index_ottawa > -1) {
            service_terms_arr.splice(index_ottawa, 1);
            howmany_inner_locations -= 1;
          }
        }

        //since the service_terms_arr can contain "undergraduate" and "graduate" , it will impossible to 100% becuase you can only choose one of these options , so for all radio options i will do a check and remove the ones the user did not pick

        const service_primary_modality = index.service_primary_modality.map(
          (v) => v.toLowerCase()
        );

        const intersection_len = responseTerms.filter((element) =>
          service_terms_arr.includes(element)
        ).length;

        index.val = intersection_len / service_terms_arr.length;

        var remove_flag = false;

        // 2 - undergraduate , 1- graduate or undergrade , 0 - not undergrade or graduate
        /*
        const intersection_len_grad_status = service_terms_arr.filter(
          (element) => q3_1.includes(element)
        ).length;

        const intersection_len_location_status = service_terms_arr.filter(
          (element) => q3_2.includes(element)
        ).length;
        */

        /*



        if (intersection_len_grad_status === 1) {
          if (
            (!service_terms_arr.includes("undergraduate") &&
              responseTerms.includes("undergraduate")) ||
            (!service_terms_arr.includes("graduate") &&
              responseTerms.includes("graduate"))
          ) {
            index.val = 0;
          }
        }
        if (intersection_len_location_status === 1) {
          if (
            (!service_terms_arr.includes("international") &&
              responseTerms.includes("international")) ||
            (!service_terms_arr.includes("domestic") &&
              responseTerms.includes("domestic"))
          ) {
            index.val = 0;
          }
        }
        */

        if (
          index.service_title ===
          "Counselling Services at Health and Counselling"
        ) {
          this.healthandCounsellingServices = index;
        }

        if (
          service_terms_arr.includes("first year") &&
          responseTerms.includes("upper") &&
          index.service_title === "First Year Connections"
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("first year") &&
          index.service_title === "First Year Connections" &&
          !remove_flag
        ) {
          index.val += 300;
        }

        //start - these 2 condtions are ones that will appear at the  top no matter what if the condtions are met

        if (
          responseTerms.includes("residence") &&
          index.service_title === "Residence Counselling" &&
          !remove_flag
        ) {
          index.val += 10000;
        }

        if (
          responseTerms.includes("sexual violence") &&
          !responseTerms.includes("abroad") &&
          index.service_title === "Sexual Assault and Trauma Counselling" &&
          !remove_flag
        ) {
          index.val += 10000;
        }

        //end

        if (index.service_title === "Carleton Disability Awareness Centre") {
          index.val = 0;
          remove_flag = true;
        }

        if (
          (responseTerms.includes("abroad") ||
            responseTerms.includes("canada")) &&
          (index.service_title === "MAX Ottawa" ||
            index.service_title ===
              "Coalition of Community Health and Resource Centres of Ottawa " ||
            index.service_title ===
              "LGBTQ+ & Trans Health Program (Centretown Community Health Centre)" ||
            index.service_title === "LGBT Youth Line") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          (responseTerms.includes("abroad") ||
            responseTerms.includes("canada")) &&
          (index.service_title === "Ottawa Distress Centre") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }


        if (
          index.service_title.indexOf("Counselling") > -1 &&
          responseTerms.includes("abroad") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }



        if (
          (!responseTerms.includes("indigenous") ||
            !responseTerms.includes("first year")) &&
          index.service_title === "Indigenous Peer Mentor Program " &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("indigenous") &&
          responseTerms.includes("first year") &&
          index.service_title === "Indigenous Peer Mentor Program " &&
          !remove_flag
        ) {
          index.val += 500;
        }

        if (
          !responseTerms.includes("finances") &&
          index.service_title === "Awards Office" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("food") &&
          index.service_title === "Food Centre" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("food") &&
          index.service_title === "Food Centre" &&
          !remove_flag
        ) {
          index.val += 1100;
        }

        if (
          !responseTerms.includes("sexual violence") &&
          (index.service_title ===
            "Carleton University Sexual Assault Support Centre CHAT" ||
            index.service_title ===
              "Carleton University Sexual Assault Support Centre CHAT" ||
            index.service_title === "Sexual Assault Support Services" ||
            index.service_title === "Sexual Assault and Trauma Counselling") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("canada") &&
          responseTerms.includes("sexual violence") &&
          (index.service_title === "Sexual Assault Support Services" ||
            index.service_title === "Sexual Assault and Trauma Counselling" ||
            index.service_title ===
              "The Sexual Assault Support Centre of Ottawa") &&
          !remove_flag
        ) {
          index.val += 1500;
        }

        if (
          !responseTerms.includes("abroad") &&
          responseTerms.includes("sexual violence") &&
          index.service_title === "Ottawa Rape Crisis Centre" &&
          !remove_flag
        ) {
          index.val += 700;
        }

        if (
          !responseTerms.includes("academics") &&
          index.service_title === "Academic Advising Centre" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("academics") &&
          index.service_title === "Academic Advising Centre" &&
          !remove_flag
        ) {
          index.val += 900;
        }

        if (
          responseTerms.includes("academics") &&
          index.service_title === "FITA" &&
          !remove_flag
        ) {
          index.val += 900;
        }

        if (
          responseTerms.includes("bereavement") &&
          index.service_title ===
            "Bereaved Families Of Ontario Ottawa Region (BFO Ottawa)" &&
          !remove_flag
        ) {
          index.val += 900;
        }

        if (
          !responseTerms.includes("campus life") &&
          index.service_title === "Campus Activity Board" &&
          !remove_flag
        ) {
          index.val -= 1000;
        }

        if (
            responseTerms.includes("legal") &&
            index.service_title === "Ombuds Services" &&
            !remove_flag
        ) {
          index.val += 1000;
        }

        if (
          responseTerms.includes("campus life") &&
          index.service_title === "Campus Activity Board" &&
          !remove_flag
        ) {
          index.val += 200;
        }

        if (
          service_terms_arr.includes("undergraduate") &&
          responseTerms.includes("graduate") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          service_terms_arr.includes("residence") &&
          !responseTerms.includes("residence") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("abroad") &&
          index.service_title === "International SOS" &&
          !remove_flag
        ) {
          index.val += 1000;
        }

        if (
          responseTerms.includes("abroad") &&
          (index.service_title ===
            "The Sexual Assault Support Centre of Ottawa" ||
            index.service_title ===
              "Coalition of Community Health and Resource Centres of Ottawa") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("international") &&
          (index.service_title === "International Student Service Office" ||
            index.service_title === "International Student Counselling") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("abroad") &&
          index.service_title === "The Global PALS Program" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("discrimination") && !responseTerms.includes("legal")
            &&
          (index.service_title === "Ombuds Services" ||
            index.service_title === "Equity and Inclusive Communities") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }
//

//


        if (
          !responseTerms.includes("wise") &&
          (index.service_title ===
            "Carleton University Women in Science and Engineering (WISE)" ||
            index.service_title === "Womxn's Centre") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("racialized") &&
          !responseTerms.includes("black") &&
          index.service_title ===
            "The Afro-Caribbean Mentorship Program (ACMP)" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          (responseTerms.includes("racialized") ||
            responseTerms.includes("black") ||
            responseTerms.includes("muslim")) &&
          index.service_title === "Racialized Student Counselling" &&
          !remove_flag
        ) {
          index.val += 2500;
        }

        if (
          (responseTerms.includes("trans") ||
            responseTerms.includes("2slgbtq+")) &&
          index.service_title === "Trans/2SLGTBQ+ Student Counselling" &&
          !remove_flag
        ) {
          index.val += 2500;
        }

        if (
          !responseTerms.includes("indigenous") &&
          (index.service_title === "Indigenous Student Counselling" ||
            index.service_title === "Native Youth Crisis Hotline" ||
            index.service_title === "Mawandoseg") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("indigenous") &&
          index.service_title === "Indigenous Student Counselling" &&
          !remove_flag
        ) {
          index.val += 2500;
        }

        if (
          responseTerms.includes("indigenous") &&
          index.service_title === "Native Youth Crisis Hotline" &&
          !remove_flag
        ) {
          index.val += 400;
        }

        if (
          !responseTerms.includes("substance") &&
          index.service_title === "All People All Pathways" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("substance") &&
          index.service_title === "Access MHA" &&
          !remove_flag
        ) {
          index.val += 1000;
        }


        // new question

        if (
            responseTerms.includes("gambling") &&
            index.service_title === "Connex Ontario" &&
            !remove_flag
        ) {
          index.val += 1000;
        }

        if (
            responseTerms.includes("housing") &&
            index.service_title === "eMentalHealth.ca" &&
            !remove_flag
        ) {
          index.val += 1000;
        }



        if (
            responseTerms.includes("domestic violence") &&
            index.service_title === "OCTEVAW" &&
            !remove_flag
        ) {
          index.val += 1000;
        }


        if (
          responseTerms.includes("substance") &&
          responseTerms.includes("campus life") &&
          index.service_title === "All People All Pathways" &&
          !remove_flag
        ) {
          index.val += 500;
        }

        if (
          responseTerms.includes("stressed") &&
          index.service_title === "Rethinking Resilience" &&
          !remove_flag
        ) {
          index.val += 500;
        }
        if (
          responseTerms.includes("trans") &&
          index.service_title === "Gender and Sexuality Resource Centre" &&
          !remove_flag
        ) {
          index.val += 500;
        }

        if (
          !responseTerms.includes("eating disorders") &&
          (index.service_title === "Body Brave" ||
            index.service_title === "Hopewell Eating Disorder Support Centre" ||
            index.service_title ===
              "National Eating Disorder Information Centre (NEDIC)") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("eating disorders") &&
          (index.service_title === "Body Brave" ||
            index.service_title === "Hopewell Eating Disorder Support Centre" ||
            index.service_title ===
              "National Eating Disorder Information Centre (NEDIC)") &&
          !remove_flag
        ) {
          index.val += 900;
        }

        if (
          !responseTerms.includes("employability") &&
          index.service_title === "Job Search Support" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          (!responseTerms.includes("stressed") ||
            !responseTerms.includes("anxious")) &&
          index.service_title === "AbilitiCBT" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          !responseTerms.includes("bereavement") &&
          index.service_title ===
            "Bereaved Families Of Ontario Ottawa Region (BFO Ottawa)" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }
        if (
          !responseTerms.includes("graduate") &&
          (index.service_title === "Graduate Students' Association (GSA)" ||
            index.service_title === "Graduate Student Counselling") &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }
        if (
          !responseTerms.includes("abroad") &&
          index.service_title === "International SOS" &&
          !remove_flag
        ) {
          index.val = 0;
          remove_flag = true;
        }

        if (
          responseTerms.includes("black") &&
          responseTerms.includes("discrimination") &&
          index.service_title === "Residence Counselling" &&
          !remove_flag
        ) {
          index.val += 900;
        }

        if (
          (responseTerms.includes("upset") ||
            responseTerms.includes("depressed") ||
            (responseTerms.includes("sad") &&
              responseTerms.includes("graduate"))) &&
          index.service_title === "Graduate Student Counselling" &&
          !remove_flag
        ) {
          index.val += 700;
        }

        if (
          (responseTerms.includes("upset") ||
            responseTerms.includes("depressed") ||
            (responseTerms.includes("sad") &&
              responseTerms.includes("undergraduate"))) &&
          index.service_title === "Empower Me Counselling Services" &&
          !remove_flag
        ) {
          index.val += 700;
        }

        if (
          responseTerms.includes("2slgbtq+") &&
          service_terms_arr.includes("2slgbtq+") &&
          !remove_flag
        ) {
          index.val += 700;
        }
        if (
          (responseTerms.includes("upset") ||
            responseTerms.includes("depressed") ||
            responseTerms.includes("sad")) &&
          responseTerms.includes("abroad") &&
          index.service_title === "International SOS" &&
          !remove_flag
        ) {
          index.val += 700;
        }

        if (
          index.service_title === "Graduate Students' Association (GSA)" &&
          !remove_flag
        ) {
          index.nav_app_priority = "2";
        }

        if (
          !(
            service_terms_arr_inital.includes("undergraduate") &&
            service_terms_arr_inital.includes("graduate") &&
            service_terms_arr_inital.includes("first year") &&
            service_terms_arr_inital.includes("international") &&
            service_terms_arr_inital.includes("domestic")
          ) &&
          !remove_flag
        ) {
          /* q3 check */

          let q3answer = Object.values(store.getters.questionThreeAnswer);

          q3answer = q3answer.map((v) => v.toLowerCase());

          const q3_intersection_len = q3answer.filter((element) =>
            service_terms_arr.includes(element)
          ).length;

          index.val += q3_intersection_len * 100;

          /*q4 check */

          let q4answer = Object.values(store.getters.questionFourAnswer);

          q4answer = q4answer.map((v) => v.toLowerCase());

          const q4_intersection_len = q4answer.filter((element) =>
            service_terms_arr.includes(element)
          ).length;

          index.val += q4_intersection_len * 100;

          /* the more services that get added this line of code will impove accuate results

          if (intersection_len / service_terms_arr.length <= 0.2) {
            index.val = 0;
          }

          */

          if (index.val > 0) {
            if (index.nav_app_priority === "1") {
              index.val += 1000;
            } else if (index.nav_app_priority === "2") {
              index.val += 500;
            }

            // }

            const modality_answer = modes.map((v) => v.toLowerCase());

            const modality_len = modality_answer.filter((element) =>
              service_primary_modality.includes(element)
            ).length;

            if (
              modality_len === service_primary_modality.length &&
              service_primary_modality.length > 0
            ) {
              index.val += 100;
            }
          }
        }
      });

      this.merged2And3 = this.sortedArr2.concat(this.sortedArr3);
      this.merged2And3ServiceTotal = this.merged2And3.length;

      /*sort the array in terms of thier val */

      store.state.services.sort(function (a, b) {
        return b.val - a.val;
      });

      let index = 0;

      let conditional_services = 0;

      while (store.state.services[index].val > 0) {
        if (index > 7) {
          if (
            store.state.services[index].service_terms_arr.includes(
              "Undergraduate"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "Graduate"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "First year"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "International"
            ) &&
            store.state.services[index].service_terms_arr.includes("Domestic")
          ) {
            if (conditional_services < 10) {
              this.allSortedResultsArr_reserve.push(
                store.state.services[index]
              );
              index += 1;
              conditional_services++;
            } else {
              index += 1;
            }
          } else {
            this.allSortedResultsArr_reserve.push(store.state.services[index]);
            index += 1;
          }
        } else {
          this.allSortedResultsArr.push(store.state.services[index]);
          index += 1;

          if (
            store.state.services[index].service_terms_arr.includes(
              "Undergraduate"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "Graduate"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "First year"
            ) &&
            store.state.services[index].service_terms_arr.includes(
              "International"
            ) &&
            store.state.services[index].service_terms_arr.includes("Domestic")
          ) {
            if (conditional_services < 10) {
              conditional_services++;
            }
          }
        }
      }

      let special_counselling = false;

      //health conditions check on both array and reserve array

      if (!responseTerms.includes("abroad")) {
        for (let n = 0; n < this.allSortedResultsArr.length; n++) {
          if (
            this.allSortedResultsArr[n].service_title ===
              "Indigenous Student Counselling" ||
            this.allSortedResultsArr[n].service_title ===
              "Racialized Student Counselling" ||
            this.allSortedResultsArr[n].service_title ===
              "Sexual Assault and Trauma Counselling" ||
            this.allSortedResultsArr[n].service_title ===
              "Trans/2SLGTBQ+ Student Counselling"
          ) {
            special_counselling = true;
            break;
          }
        }
        if (special_counselling === false) {
          for (let m = 0; m < this.allSortedResultsArr_reserve.length; m++) {
            if (
              this.allSortedResultsArr_reserve[m].service_title ===
                "Indigenous Student Counselling" ||
              this.allSortedResultsArr_reserve[m].service_title ===
                "Racialized Student Counselling" ||
              this.allSortedResultsArr_reserve[m].service_title ===
                "Sexual Assault and Trauma Counselling" ||
              this.allSortedResultsArr_reserve[m].service_title ===
                "Trans/2SLGTBQ+ Student Counselling"
            ) {
              special_counselling = true;
              break;
            }
          }
        }

        if (special_counselling === false) {
          //this will put the health and counselling services at the top of the first array , it will have 9 services total now
          // this produces an empty element in results set
          // this.allSortedResultsArr.splice(
          //   1,
          //   0,
          //   this.healthandCounsellingServices
          // );

          let temp_8 = this.allSortedResultsArr[8];

          Vue.set(this.allSortedResultsArr, 8, null);
          this.allSortedResultsArr.splice(8, 1);

          this.allSortedResultsArr_reserve.splice(0, 0, temp_8);
        }
      }

      //used to show what ids and what the val of each service is

      /*

      console.log("------------- First 8 -------------");

      for (let j = 0; j < this.allSortedResultsArr.length; j++) {
        console.log(
          this.allSortedResultsArr[j].service_title +
            " | val: " +
            this.allSortedResultsArr[j].val
        );
      }

      console.log("------------- Reserves -------------");

      for (let k = 0; k < this.allSortedResultsArr_reserve.length; k++) {
        console.log(
          this.allSortedResultsArr_reserve[k].service_title +
            " | val: " +
            this.allSortedResultsArr_reserve[k].val
        );
      }

      console.log("----------------");
      console.log("end of sorting");
      console.log("----------------");
      */

      /*end of sorting */

      //alt console.log for titles

      // update the resources docs to display where values match
      // grab the value from Q9
      /*
      if (store.state.service_terms.includes("help a friend")) {
        this.helpForFriend = true;
      }
      */
      // grab the value from Q10
      if (store.state.service_terms.includes("In Crisis")) {
        this.mentalHealthContinuum.complex.value++;
      }

      // count it out and rank the continuum indicators

      var continuumValuesArray = new Array(
        this.mentalHealthContinuum.thriving.value,
        this.mentalHealthContinuum.everyday_stress.value,
        this.mentalHealthContinuum.mild.value,
        this.mentalHealthContinuum.moderate.value,
        this.mentalHealthContinuum.complex.value
      );
      const largest = Math.max(...continuumValuesArray);
      this.largestVal = largest;
      const continuumIndex = continuumValuesArray.indexOf(largest);
      //console.log(continuumIndex);
      if (continuumIndex == 0) {
        // you are thriving
        this.continuumVal = "Thriving";
        this.continuumName = this.mentalHealthContinuum.thriving.name;
        this.continuumDescription =
          this.mentalHealthContinuum.thriving.description;
      } else if (continuumIndex == 1) {
        // you are dealing with everyday stress
        this.continuumVal = "Everyday Stress";
        this.continuumName = this.mentalHealthContinuum.everyday_stress.name;
        this.continuumDescription =
          this.mentalHealthContinuum.everyday_stress.description;
      } else if (continuumIndex == 2) {
        // you are dealing with mild mental health concerns
        this.continuumVal = "Mild Mental Health Concerns";
        this.continuumName = this.mentalHealthContinuum.mild.name;
        this.continuumDescription = this.mentalHealthContinuum.mild.description;
      } else if (continuumIndex == 3) {
        // you are dealing moderate mental health concerns
        this.continuumVal = "Moderate mental Health Concerns";
        this.continuumName = this.mentalHealthContinuum.moderate.name;
        this.continuumDescription =
          this.mentalHealthContinuum.moderate.description;
      } else if (continuumIndex == 4) {
        // you are dealing moderate mental health concerns
        this.continuumVal = "Complex mental health concerns";
        this.continuumName = this.mentalHealthContinuum.complex.name;
        this.continuumDescription =
          this.mentalHealthContinuum.complex.description;
      }

      //this.setHeightsofContinuum(largest);
      this.findTotalServices();
      this.setMiddleWidgets();
      this.getEvents();
    },

    setHeightsofContinuum(largest) {
      var height = 0;

      //console.log(largest);

      var total =
        this.mentalHealthContinuum.thriving.value +
        this.mentalHealthContinuum.everyday_stress.value +
        this.mentalHealthContinuum.mild.value +
        this.mentalHealthContinuum.moderate.value +
        this.mentalHealthContinuum.complex.value;

      //thriving

      height = (this.mentalHealthContinuum.thriving.value / total) * 100;

      this.mentalHealthContinuum.thriving.percentageFull = height.toFixed(1);

      if (isNaN(height)) {
        height = "0px";
      } else if (!isNaN(height)) {
        height = JSON.stringify(height) + "px";
      }

      this.styleThriving.height = height;

      if (largest === this.mentalHealthContinuum.thriving.value) {
        this.styleThriving.background = "#6C63FF";
        this.styleThriving.animation = "color 2s infinite";
        this.moreThanOneContinuumFlag++;
      }

      //everyday stress

      height = (this.mentalHealthContinuum.everyday_stress.value / total) * 100;

      this.mentalHealthContinuum.everyday_stress.percentageFull =
        height.toFixed(1);
      if (isNaN(height)) {
        height = "0px";
      } else if (!isNaN(height)) {
        height = JSON.stringify(height) + "px";
      }

      this.styleEveryday_stress.height = height;

      if (largest === this.mentalHealthContinuum.everyday_stress.value) {
        this.styleEveryday_stress.background = "#6C63FF";
        this.styleEveryday_stress.animation = "color 2s infinite";

        this.moreThanOneContinuumFlag++;
      }

      //mild

      height = (this.mentalHealthContinuum.mild.value / total) * 100;

      this.mentalHealthContinuum.mild.percentageFull = height.toFixed(1);

      if (isNaN(height)) {
        height = "0px";
      } else if (!isNaN(height)) {
        height = JSON.stringify(height) + "px";
      }

      this.styleMild.height = height;

      if (largest === this.mentalHealthContinuum.mild.value) {
        this.styleMild.background = "#6C63FF";
        this.styleMild.animation = "color 2s infinite";
        this.moreThanOneContinuumFlag++;
      }

      //moderate

      height = (this.mentalHealthContinuum.moderate.value / total) * 100;

      this.mentalHealthContinuum.moderate.percentageFull = height.toFixed(1);

      if (isNaN(height)) {
        height = "0px";
      } else if (!isNaN(height)) {
        height = JSON.stringify(height) + "px";
      }

      this.styleModerate.height = height;

      if (largest === this.mentalHealthContinuum.moderate.value) {
        this.styleModerate.background = "#6C63FF";
        this.styleModerate.animation = "color 2s infinite";
        this.moreThanOneContinuumFlag++;
      }

      //complex

      height = (this.mentalHealthContinuum.complex.value / total) * 100;

      this.mentalHealthContinuum.complex.percentageFull = height.toFixed(1);

      if (isNaN(height)) {
        height = "0px";
      } else if (!isNaN(height)) {
        height = JSON.stringify(height) + "px";
      }

      this.styleComplex.height = height;

      if (largest === this.mentalHealthContinuum.complex.value) {
        this.styleComplex.background = "#6C63FF";
        this.styleComplex.animation = "color 2s infinite";
        this.moreThanOneContinuumFlag++;
      }

      if (this.moreThanOneContinuumFlag > 1) {
        this.moreThanOneContinuumBoolean = true;
        this.conditionalWidth = "0 1 100%";
      } else {
        this.conditionalWidth = "";
      }

      //color of the bar
    },

    findTotalServices() {
      /*
      if (this.crisisBoolean) {
        this.totalServices = this.crisisArr.length;
        // console.log("Crisis services: " + this.totalServices);
      } else {
        this.totalServices = this.sortedArr.length;
        //this.sortedArr2.length +
        //this.sortedArr3.length;
        //console.log("Non Crisis services: " + this.totalServices);
      }
      */
      this.totalServices =
        this.allSortedResultsArr.length +
        this.allSortedResultsArr_reserve.length;
    },

    setMiddleWidgets() {
      /*
      //health plan
      var healthPlan = store.getters.questionSixAnswer[0];
      /*var undergraduate_graduate = store.getters.questionTwoAnswer[0];

      if (healthPlan.toLowerCase() === "ohip") {
        this.healthCoverageFlag = true;
        this.currentHealthCoverage.title =
          this.staticResources.healthCoverage.ohip.title;
        this.currentHealthCoverage.description =
          this.staticResources.healthCoverage.ohip.description;
        this.currentHealthCoverage.url =
          this.staticResources.healthCoverage.ohip.url;
      }
      /*else if (
        healthPlan.toLowerCase() === "cusa" ||
        (healthPlan.toLowerCase() === "unsure" &&
          undergraduate_graduate.toLowerCase() === "undergraduate")
      ) {
        this.healthCoverageFlag = true;
        this.currentHealthCoverage.title =
          this.staticResources.healthCoverage.cusa.title;
        this.currentHealthCoverage.description =
          this.staticResources.healthCoverage.cusa.description;
        this.currentHealthCoverage.url =
          this.staticResources.healthCoverage.cusa.url;
      }
      */
      //primary reason
      /*
      const primaryReason = store.getters.questionEightAnswer[0];

      if (primaryReason.includes("friend")) {
        this.frameworkWidget = true;
        this.currentPrimaryReason.title =
          this.staticResources.primaryReason.friend.title;
        this.currentPrimaryReason.description =
          this.staticResources.primaryReason.friend.description;
        this.currentPrimaryReason.url =
          this.staticResources.primaryReason.friend.url;
      } else if (primaryReason.includes("self")) {
        this.frameworkWidget = true;
        this.currentPrimaryReason.title =
          this.staticResources.primaryReason.self.title;
        this.currentPrimaryReason.description =
          this.staticResources.primaryReason.self.description;
        this.currentPrimaryReason.url =
          this.staticResources.primaryReason.self.url;
      } else {
        this.currentPrimaryReason.title =
          this.staticResources.primaryReason.other.title;
        this.currentPrimaryReason.description =
          this.staticResources.primaryReason.other.description;
        this.currentPrimaryReason.url =
          this.staticResources.primaryReason.other.url;
      }
      */
    },

    getEvents() {
      //console.log("hello");
      let eventsUrl;
      if (window.location.hostname == "localhost") {
        eventsUrl = "https://students-dev.carleton.ca";
      } else {
        //TODO: change this to PROD on launch
        eventsUrl = "https://students.carleton.ca";
      }
      /*let terms = this.$store.state.views.questionSeven.answer;*/
      let terms = ["wellness"];
      axios
        .get(eventsUrl + "/wp-json/stu-api/v2/events/pillar/" + terms)
        .then((response) => store.commit("SET_EVENTS", response.data));

      store.commit("SET_EVENTS_LOADING");
    },

    /*
    feelingEmoji() {
      const feeling = store.getters.questionOneAnswer;

      //if the answer array is length=2 , and the index at 1 is from the slider , then display their feeling

      if (
        (feeling[0] === this.conditionalFeelings[0] ||
          feeling[0] === this.conditionalFeelings[1]) &&
        (feeling[1] === "Mild" ||
          feeling[1] === "Moderate" ||
          feeling[1] === "Severe" ||
          feeling[1] === "Extremely severe")
      ) {
        this.condtionalFlag = true;
      }

      //set the feeling and current emoji mapped the question one answer

      this.currFeelingWords = feeling[0];

      this.currFeeling = this.getKeyByValue(this.feelingsAndEmjois, feeling[0]);
    },

    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
*/
    checkDarkModeStatus() {
      const root = document.querySelector("html");
      let contains = root.classList.contains("dark");
      if (contains) {
        this.darkSideLogo = true;
      }
    },
    openContinuumModal() {
      this.continuumModalOpen = true;
    },

    checkResultsStyleLoader() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('view') === "app") {
        this.showResultsHeader = "none";
      }
    },

    goRightTop() {
      document.getElementById("toSlide").scrollLeft += 572;
    },

    goLeftTop() {
      document.getElementById("toSlide").scrollLeft -= 572;
    },

    goRightBottom() {
      document.getElementById("toSlide2").scrollLeft += 572;
    },

    goLeftBottom() {
      document.getElementById("toSlide2").scrollLeft -= 572;
    },

    findSubString(responseTerms, item) {
      if (item.length !== 0) {
        for (var i = 0; i < responseTerms.length; i++) {
          if (
            item.includes(responseTerms[i]) ||
            responseTerms[i].includes(item)
          ) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
.modalOverlayClose_reduced {
  @apply fixed w-full h-full bg-black top-0 bottom-0 opacity-10 z-30 left-0 py-0;
}

#scrollLeftButton:disabled,
#scrollRightButton:disabled,
#scrollRightButton2:disabled,
#scrollLeftButton2:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.bar {
  display: block;
  width: 42px;
  animation-name: color;

  position: absolute;
  bottom: 0px;
}

@media only screen and (max-width: 768px) {
  .bar {
    width: 25px;
  }
}

.continuumDialog {
  @apply fixed px-16 py-10 bg-white  shadow-lg z-50;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
  width: 30%;
  border-radius: 20px;
}

@media only screen and (max-width: 1435px) {
  .continuumDialog {
    @apply py-8;
    width: 40%;
  }
}

@media only screen and (max-width: 1070px) {
  .continuumDialog {
    @apply py-8;
    width: 50%;
  }
}

@media only screen and (max-width: 865px) {
  .continuumDialog {
    @apply py-8;
    width: 70%;
  }
}

@media only screen and (max-width: 640px) {
  .continuumDialog {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-8;
  }
}
</style>
